export const HOME_URL = '/'
export const TUTORING_URL = '/tutoring'

// External
export const APPOINTMENTS_URL =
  'https://squareup.com/appointments/buyer/widget/e8ldy46h210fdy/RXSQ86YK7MMP0'
